/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdWebFeaturesProfileGetRequest interface.
 */
export function instanceOfFxIdWebFeaturesProfileGetRequest(value) {
    return true;
}
export function FxIdWebFeaturesProfileGetRequestFromJSON(json) {
    return FxIdWebFeaturesProfileGetRequestFromJSONTyped(json, false);
}
export function FxIdWebFeaturesProfileGetRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Game': json['Game'] == null ? undefined : json['Game'],
    };
}
export function FxIdWebFeaturesProfileGetRequestToJSON(json) {
    return FxIdWebFeaturesProfileGetRequestToJSONTyped(json, false);
}
export function FxIdWebFeaturesProfileGetRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Game': value['Game'],
    };
}
//# sourceMappingURL=FxIdWebFeaturesProfileGetRequest.js.map